import { cn } from '@/lib/cn';

/**
 * Prometheus brand accent — the orange used across the marketing surface
 * (landing page, auth, "coming soon"). Mirrors `LandingPage`'s ACCENT.
 */
export const BRAND_ACCENT = '#ff6b35';

/**
 * The Prometheus wordmark lockup: orange "Prometheus" + muted "Legal
 * Intelligence" in the chrome typeface. Matches the landing page header so
 * the auth and coming-soon surfaces carry the same brand treatment instead
 * of the legacy "PatPro" wordmark.
 */
export function Wordmark({
  size = 'md',
  className,
}: {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}) {
  const sizeClass = size === 'lg' ? 'text-lg' : size === 'sm' ? 'text-sm' : 'text-base';
  return (
    <span
      className={cn(
        'font-chrome font-semibold tracking-[0.05em] uppercase leading-none',
        sizeClass,
        className,
      )}
    >
      <span style={{ color: BRAND_ACCENT }}>Prometheus</span>{' '}
      <span className="text-text-tertiary">Legal Intelligence</span>
    </span>
  );
}
